import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSEO } from '../hooks/useSEO';
import TermsContent from '../components/TermsContent';
import {
  embeddedRegisterTeamPath,
  PLAYER_LEAGUE_INFO_BASE,
} from '../utils/playerLeagueInfoEmbeddedPaths';

const TermsContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: ${(p) => (p.$embedded ? '0 0 2rem' : '2rem')};
  line-height: 1.6;
  color: var(--text-primary);
  background: var(--bg-primary);
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 3rem;
  padding: 2rem 0;
  background: linear-gradient(135deg, var(--brand-blue) 0%, var(--brand-blue-dark) 100%);
  color: white;
  border-radius: 12px;
  margin: ${(p) => (p.$embedded ? '0 0 2rem 0' : '-2rem -2rem 3rem -2rem')};
`;

const Title = styled.h1`
  font-size: 2.5rem;
  margin-bottom: 1rem;
  color: white;
`;

const Subtitle = styled.p`
  font-size: 1.1rem;
  opacity: 0.9;
  margin: 0;
`;

const BackRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-top: 2rem;
  align-items: center;
`;

const BackButton = styled(Link)`
  display: inline-block;
  background: linear-gradient(135deg, var(--brand-blue) 0%, var(--brand-blue-dark) 100%);
  color: white;
  padding: 0.8rem 2rem;
  text-decoration: none;
  border-radius: 8px;
  font-weight: 600;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(4, 54, 99, 0.3);
  }
`;

const BackButtonSecondary = styled(Link)`
  display: inline-block;
  background: transparent;
  color: var(--brand-blue);
  padding: 0.8rem 2rem;
  text-decoration: none;
  border-radius: 8px;
  font-weight: 600;
  border: 2px solid var(--brand-blue);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    background: rgba(4, 54, 99, 0.06);
  }
`;

const TermsAndConditionsPage = ({ embedded = false, appEmbed = false }) => {
  const { t } = useTranslation();

  useSEO(
    embedded
      ? {}
      : {
          title: t('termsWebsite.page.seo.title'),
          description: t('termsWebsite.page.seo.description'),
          keywords: t('termsWebsite.page.seo.keywords'),
          canonical: 'https://helveticpadelseries.ch/terms-and-conditions',
        }
  );

  return (
    <TermsContainer $embedded={embedded}>
      <Header $embedded={embedded}>
        <Title>{t('termsWebsite.page.headerTitle')}</Title>
        <Subtitle>{t('termsWebsite.page.headerSubtitle')}</Subtitle>
      </Header>

      <TermsContent />

      {!appEmbed && (
        <BackRow>
          <BackButton to={embedded ? PLAYER_LEAGUE_INFO_BASE : '/'}>
            {embedded ? t('phase2.playerLeagueInfo.allTopics') : t('termsWebsite.page.backToHome')}
          </BackButton>
          <BackButtonSecondary to={embedded ? embeddedRegisterTeamPath() : '/register'}>
            {t('termsWebsite.page.backToRegistration')}
          </BackButtonSecondary>
        </BackRow>
      )}
    </TermsContainer>
  );
};

export default TermsAndConditionsPage;
